// @flow
export const ATTEMPT_CREATE_RECIPE = 'hive/recipes/ATTEMPT_CREATE_RECIPE';
export const ATTEMPT_DELETE_RECIPE = 'hive/recipes/ATTEMPT_DELETE_RECIPE';
export const ATTEMPT_UPDATE_RECIPE = 'hive/recipes/ATTEMPT_UPDATE_RECIPE';
export const CANCEL_ACTION = 'hive/recipes/CANCEL_ACTION';
export const CANCEL_TEMPLATE = 'hive/recipes/CANCEL_TEMPLATE';
export const EDIT_RECIPE = 'hive/recipes/EDIT_RECIPE';
export const EDIT_SCHEDULE = 'hive/recipes/EDIT_SCHEDULE';
export const GET_RECIPES = 'hive/recipes/GET_RECIPES';
export const HANDLE_NOTIFICATION_CHANGE = 'hive/recipes/HANDLE_NOTIFICATION_CHANGE';
export const HANDLE_PROPERTY_CHANGE = 'hive/recipes/HANDLE_PROPERTY_CHANGE';
export const HIDE_MODAL = 'hive/recipes/HIDE_MODAL';
export const RECEIVE_RECIPES = 'hive/recipes/RECEIVE_RECIPES';
export const REQUEST_CONFIRM_DELETE = 'hive/recipes/REQUEST_CONFIRM_DELETE';
export const SELECT_CONSUMER = 'hive/recipes/SELECT_CONSUMER';
export const SELECT_PRODUCER = 'hive/recipes/SELECT_PRODUCER';
export const SELECT_TEMPLATE = 'hive/recipes/SELECT_TEMPLATE';
export const SHOW_TEMPLATES_LIST = 'hive/recipes/SHOW_TEMPLATES_LIST';
export const TOGGLE_SCHEDULE_STATE = 'hive/recipes/TOGGLE_SCHEDULE_STATE';
export const UPDATE_DATA = 'hive/recipes/UPDATE_DATA';
export const UPDATE_RECIPE = 'hive/recipes/UPDATE_RECIPE';



// WEBPACK FOOTER //
// ./src/core/state/recipes/constants.js